import { combineReducers } from 'redux-immutable';

import { CatalogKeys } from '../../constants/Catalog';
import mapApiDataToSubstate from '../../lib/configuration/ApiDataMapper';
import createFilter from '../../tools/ReduxPersistFilter';
import { type IMapOf } from '../../types';

import artistsReducer, { type EntitiesArtistState } from './Artists';
import browseSourcesReducer, { type EntitiesBrowseSourceState } from './BrowseSource';
import catalogReducer, { type EntitiesCatalogState } from './Catalog';
import catalogStationsReducer, { type EntitiesCatalogStationsState } from './CatalogStations';
import categoriesReducer, { type EntitiesCategoriesState } from './Categories';
import curatorSourcesReducer, { type EntitiesCuratorSourcesState } from './CuratorSources';
import genresReducer, { type EntitiesGenresState } from './Genres';
import listenersReducer, { type EntitiesListenerState } from './Listeners';
import lyricsReducer, { type EntitiesLyricsState } from './Lyrics';
import playlistReducer, { type EntitiesPlaylistsState } from './Playlists';
import playlistTracksReducer, { type EntitiesPlaylistTracksState } from './PlaylistTracks';
import seedsReducer, { type EntitiesSeedsState } from './Seeds';
import stationsReducer, { type EntitiesStationsState } from './Stations';
import tracksReducer, { type EntitiesTracksState } from './Tracks';

export function getPreloadedApiData() {
  return window._store;
}

export type EntitiesState = IMapOf<{
  artists: EntitiesArtistState;
  browseSources: EntitiesBrowseSourceState;
  catalog: EntitiesCatalogState;
  catalogStations: EntitiesCatalogStationsState;
  categories: EntitiesCategoriesState;
  curatorSources: EntitiesCuratorSourcesState;
  genres: EntitiesGenresState;
  listeners: EntitiesListenerState;
  lyrics: EntitiesLyricsState;
  playlists: EntitiesPlaylistsState;
  playlistTracks: EntitiesPlaylistTracksState;
  seeds: EntitiesSeedsState;
  stations: EntitiesStationsState;
  tracks: EntitiesTracksState;
}>;
const SERVER_SIDE_INITIAL_STATE = mapApiDataToSubstate(
  getPreloadedApiData(),
) as unknown as EntitiesState;

// @ts-expect-error
export const EntityFilter = createFilter({
  reducer: 'entities',
  keys: ['listeners', 'playlistTracks', 'stations', 'catalog'],
  inbound(state: EntitiesState) {
    let newState = state;

    const catalogMap = state.get(CatalogKeys.CATALOG);
    if (catalogMap) {
      const persistedCatalogMap = catalogMap.filter((_: unknown, key) => {
        return CatalogKeys.CURRENT_SOURCE_ID === key;
      });

      newState = state.setIn([CatalogKeys.CATALOG], persistedCatalogMap);
    }

    return newState;
  },
  outbound(state: EntitiesState) {
    // initial state when being rehydrated from redux-persist
    return state.mergeDeep(SERVER_SIDE_INITIAL_STATE);
  },
});

// initial state on first visit to site
export default (state: EntitiesState = SERVER_SIDE_INITIAL_STATE, action: $TSFixMe) =>
  combineReducers<EntitiesState>({
    artists: artistsReducer,
    catalog: catalogReducer,
    categories: categoriesReducer,
    curatorSources: curatorSourcesReducer,
    genres: genresReducer,
    listeners: listenersReducer,
    lyrics: lyricsReducer,
    playlists: playlistReducer,
    playlistTracks: playlistTracksReducer,
    seeds: seedsReducer,
    stations: stationsReducer,
    tracks: tracksReducer,
    // Just used for browse
    browseSources: browseSourcesReducer,
    catalogStations: catalogStationsReducer,
  })(state, action);
